import Validator from 'validatorjs'
import isEmpty from 'lodash/isEmpty'
import {
  CTA_FORM_NAMES, CUSTOM_FORM_FIELD_STATES , VALIDATION_ERRORS
} from 'LiveBoard/components/shared/CallToAction/types/forms/constants'

const FORM_VALIDATIONS = {
  [CTA_FORM_NAMES.share]: {
    rules: {
      email: 'required|email',
      invitee: 'required|email'
    },
    errorMessages: {
      required: VALIDATION_ERRORS.required,
      email: VALIDATION_ERRORS.email
    }
  },
  [CTA_FORM_NAMES.sendMessage]: {
    rules: {
      email: 'required|email',
      message: 'required',
    },
    errorMessages: {
      required: VALIDATION_ERRORS.required,
      email: VALIDATION_ERRORS.email
    }
  },
  [CTA_FORM_NAMES.getVisitorEmail]: {
    rules: {
      email: 'required|email'
    },
    errorMessages: {
      required: VALIDATION_ERRORS.required,
      email: VALIDATION_ERRORS.email
    }
  },
  [CTA_FORM_NAMES.customForm]: {
    rules: (fields) => {
      return Object.keys(fields).reduce((rules, key) => {
        const field = fields[key]
        if(field.state != CUSTOM_FORM_FIELD_STATES.required || key in rules) {
          return rules
        }

        rules[key] = 'required'
        return rules
      }, {
        email: 'required|email'
      })
    },
    errorMessages: {
      required: VALIDATION_ERRORS.required,
      email: VALIDATION_ERRORS.email
    }
  }
}


function getPrivacyMessageValidation(checkboxes){
  const privacyRules ={
    rules: {},
    errorMessages: {
      required: VALIDATION_ERRORS.required,
      accepted: VALIDATION_ERRORS.accepted
    }
  }
  checkboxes.map((checkbox) => {
    if(!!checkbox.label && checkbox.is_required) {
      privacyRules.rules[checkbox.name] = 'required|accepted'
    }
  })
  return privacyRules
}

export function validateForm({ values, form, privacyMessageCheckboxConfig }) {
  return validate(
    values,
    FORM_VALIDATIONS[form].rules,
    FORM_VALIDATIONS[form].errorMessages,
    privacyMessageCheckboxConfig
  )
}

export function validateCustomForm({ values, form, privacyMessageCheckboxConfig, fields }) {
  return validate(
    values,
    FORM_VALIDATIONS[form].rules(fields),
    FORM_VALIDATIONS[form].errorMessages,
    privacyMessageCheckboxConfig
  )
}

function validate(values, rules, errorMessages, privacyMessageCheckboxConfig) {
  if(!isEmpty(privacyMessageCheckboxConfig)) {
    const privacyMessageValidation = getPrivacyMessageValidation(privacyMessageCheckboxConfig)
    rules = {
      ...rules,
      ...privacyMessageValidation.rules
    }

    errorMessages = {
      ...errorMessages,
      ...privacyMessageValidation.errorMessages
    }
  }

  const validator = new Validator(values, rules, errorMessages)
  validator.passes()
  return validator.errors.all()
}